'use strict';
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import * as ReactRedux from 'react-redux';
import Store from '../../redux/store.js';

if (window.APP.includes('unauthorized-access-with-sidebar')) {
    const UnauthorizedAccessPageWithSidebarHome = require('../../views/common/unauthorized-access-with-sidebar')
        .UnauthorizedAccessPageWithSidebarHome;

    const store = Store.createUnauthorizedAccessStore(window.REDUX_DATA);

    const app = document.getElementById('root');

    hydrateRoot(
        app,
        <ReactRedux.Provider store={store}>
            <UnauthorizedAccessPageWithSidebarHome />
        </ReactRedux.Provider>
    );
} else if (window.APP.includes('unauthorized-access')) {
    const UnauthorizedAccessPageHome = require('../../views/common/unauthorized-access').UnauthorizedAccessPageHome;

    const store = Store.createUnauthorizedAccessStore(window.REDUX_DATA);

    const app = document.getElementById('root');

    hydrateRoot(
        app,
        <ReactRedux.Provider store={store}>
            <UnauthorizedAccessPageHome />
        </ReactRedux.Provider>
    );
}
